import { useEffect, useRef, useCallback } from 'react';
const VIDEO_INPUT_KIND = 'videoinput';
const DESIRED_CAMERA_TYPE = 'environment';
const DESIRED_FOCUS_MODE = 'continuous';
async function findDesiredCamera({
  desiredFocusMode = DESIRED_FOCUS_MODE,
  desiredFacing = DESIRED_CAMERA_TYPE
} = {}) {
  const devices = (await navigator.mediaDevices.enumerateDevices()).filter(d => d.kind === VIDEO_INPUT_KIND);
  // can't do promise.all or certain cameras may fail to init since some are mutually exclusive
  let deviceId = null;
  for (let index = 0; index < devices.length; index++) {
    const d = devices[index];
    // eslint-disable-next-line no-await-in-loop
    const stream = await navigator.mediaDevices.getUserMedia({
      video: {
        deviceId: d.deviceId
      }
    });
    const capabilities = stream?.getVideoTracks?.()?.[0]?.getCapabilities?.();
    const focusMode = capabilities?.focusMode;
    const facing = capabilities?.facingMode;
    stream.getTracks().forEach(track => {
      track.stop();
    });
    if (focusMode?.includes(desiredFocusMode) && facing?.includes(desiredFacing)) {
      deviceId = d.deviceId;
      break;
    }
  }
  return deviceId;
}
const useRafLoop = (callback, delay) => {
  const requestRef = useRef();
  const previousTimeRef = useRef();
  const animate = useCallback(time => {
    if (previousTimeRef.current !== undefined) {
      const deltaTime = time - previousTimeRef.current;
      callback(deltaTime);
    }
    previousTimeRef.current = time;
    requestRef.current = requestAnimationFrame(animate);
  }, [callback]);
  useEffect(() => {
    requestRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(requestRef.current);
  }, [animate]);
  useEffect(() => {
    if (delay !== null && delay !== undefined) {
      const intervalId = setInterval(() => {
        callback(16); // Simulate 60 FPS (1000ms / 60)
      }, delay);
      return () => clearInterval(intervalId);
    }
    return () => {};
  }, [callback, delay]);
};
export {
// eslint-disable-next-line import/prefer-default-export
findDesiredCamera, useRafLoop };